import React from "react";

import * as classes from "./Canvas.module.css";

export function Canvas(props) {
  const { canvasRef } = props;
  return (
    <div className={classes.Canvas}>
      <canvas ref={canvasRef}></canvas>
    </div>
  );
}

export function CanvasCard(props) {
  const {
    canvasRef,
    data: { title, content },
  } = props;
  return (
    <div className={classes.CanvasCard}>
      <Canvas canvasRef={canvasRef} />
      <div className={classes.CanvasCardInfoDiv}>
        <h2>{title}</h2>
        <p>{content}</p>
      </div>
    </div>
  );
}
